@if (!showAsChip()) {
	<div class="responsible-container">
		<form-field-label [labelTranslateKey]="responsibleType()" />

		<mat-form-field>
			<mat-select [formControl]="responsible" [compareWith]="compareWith">
				<mat-select-trigger class="selected-responsible">
					{{ responsible.value?.firstName + ' ' + responsible.value?.lastName }}
				</mat-select-trigger>
				<mat-option>
					<ngx-mat-select-search
						class="responsible-search"
						[formControl]="responsibleSearch"
						[placeholderLabel]="'search' | translate"
						[noEntriesFoundLabel]="'no_results_found' | translate"
					/>
				</mat-option>
				<mat-option [value]="{ psId: null, firstName: '', lastName: '' }">
					<mat-icon svgIcon="person-cancel" />
					{{ 'none' | translate }}
				</mat-option>
				@for (user of selectableAssignees(); track user.psId) {
					<mat-option [value]="user" class="responsible-option">
						{{ user.firstName + ' ' + user.lastName }}
						<mat-icon svgIcon="account-circle" />
					</mat-option>
				}
			</mat-select>
			<mat-icon matPrefix [svgIcon]="'account-circle'" />
		</mat-form-field>
	</div>
} @else {
	<div class="responsible-chip-container">
		<mat-chip
			[aria-label]="responsibleType() | translate"
			[matMenuTriggerFor]="responsibleMenu"
		>
			<div class="responsible-chip-content">
				@if (responsible.value) {
					<mat-icon svgIcon="account-circle" />
					{{ responsible.value?.firstName + ' ' + responsible.value?.lastName }}
				} @else {
					<mat-icon svgIcon="account-circle" />
					{{ 'assignee' | translate }}
				}
			</div>
		</mat-chip>

		<mat-menu #responsibleMenu="matMenu" (closed)="responsibleSearch.setValue('')">
			<div class="responsible-menu nice-scroll colored-scroll-track visible-scroll">
				<div class="responsible-menu-search">
					<au-search-input
						[value]="responsibleSearch.value"
						(searchTextChanged)="responsibleSearch.setValue($event)"
						(keydown)="$event.stopPropagation()"
						(click)="$event.stopPropagation()"
					/>
				</div>
				@for (user of selectableAssignees(); track user.psId) {
					<button mat-menu-item (click)="responsible.setValue(user)">
						{{ user.firstName + ' ' + user.lastName }}
						<mat-icon svgIcon="account-circle" />
					</button>
				}
			</div>
		</mat-menu>
	</div>
}
